<template>
  <div class="basicBreadCrumb">
    <el-breadcrumb-item>账户管理</el-breadcrumb-item>
    <el-breadcrumb-item :class="{ active: item.url===$route.path }" :to="item.url" v-for="item in breadcrumbList" :key="item.id">{{item.name}}</el-breadcrumb-item>
  </div>
</template>
<script>
export default {
  data () {
    return {
      breadcrumbList: [],
      basicList: [
        { url: '/', name: '账户设置', index: '6-1' },
        { url: '/user/binding', name: '绑定', index: '6-1' },
        { url: '/user/cash', name: '提现', index: '6-2' },
        { url: '/user/cashList', name: '交易明细', index: '6-3' }
      ]
    }
  },
  mounted () {
    this.setBreadCrumb(this.$route)
  },
  watch: {
    $route (to, from) {
      this.setBreadCrumb(to)
    }
  },
  methods: {
    setBreadCrumb (to) {
      let currentUrl = this.basicList.filter(item => item.url === to.path)
      if (!this.breadcrumbList.some(item => item.url === to.path)) {
        this.breadcrumbList = this.breadcrumbList.concat(currentUrl)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/breadcrumb/userSet.vue